import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { InstitutionAuthUser } from './auth-user.model';

export const AuthUserActions = createActionGroup({
  source: 'AuthUser/API',
  events: {
    'Load AuthUsers': props<{ authUsers: InstitutionAuthUser[] }>(),
    'Add AuthUser': props<{ authUser: InstitutionAuthUser }>(),
    'Upsert AuthUser': props<{ authUser: InstitutionAuthUser }>(),
    'Add AuthUsers': props<{ authUsers: InstitutionAuthUser[] }>(),
    'Upsert AuthUsers': props<{ authUsers: InstitutionAuthUser[] }>(),
    'Update AuthUser': props<{ authUser: Update<InstitutionAuthUser> }>(),
    'Update AuthUsers': props<{ authUsers: Update<InstitutionAuthUser>[] }>(),
    'Delete AuthUser': props<{ id: string }>(),
    'Delete AuthUsers': props<{ ids: string[] }>(),
    'Clear AuthUsers': emptyProps(),

    // EFFECT ACTIONS

    //for clearing store
    'Logout': emptyProps,
  }
});
